import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface EmailNotificationListState {
    emailnotificationlist: {
        load: boolean;
        data: [];
    };
    NotificationCategory: {
        load: boolean;
        data: [];
    };
    NotificationCategorySummary: {
        load: boolean;
        data: [];
    }
}

export const NotificationSlice = createSlice({
    name: "emailnotificationlist",
    initialState: {
        emailnotificationlist: {
            load: false,
            data: [],
        },
        NotificationCategory: {
            load: false,
            data: [],
        },
        NotificationCategorySummary: {
            load: false,
            data: [],
        } 
    } as EmailNotificationListState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchEmailNotificationList.pending, (state: EmailNotificationListState) => {
                state.emailnotificationlist.load = true;
            })
            .addCase(fetchEmailNotificationList.fulfilled, (state: EmailNotificationListState, action: any) => {
                state.emailnotificationlist.data = action.payload;
                state.emailnotificationlist.load = false;
            })
            .addCase(fetchEmailNotificationList.rejected, (state: EmailNotificationListState) => {
                state.emailnotificationlist.load = false;
            })
            .addCase(fetchNotificationCategory.pending, (state: EmailNotificationListState) => {
                state.NotificationCategory.load = true;
            })
            .addCase(fetchNotificationCategory.fulfilled, (state: EmailNotificationListState, action: any) => {
                state.NotificationCategory.data = action.payload;
                state.NotificationCategory.load = false;
            })
            .addCase(fetchNotificationCategory.rejected, (state: EmailNotificationListState) => {
                state.NotificationCategory.load = false;
            })
            .addCase(fetchNotificationCategorySummary.pending, (state: EmailNotificationListState) => {
                state.NotificationCategorySummary.load = true;
            })
            .addCase(fetchNotificationCategorySummary.fulfilled, (state: EmailNotificationListState, action: any) => {
                state.NotificationCategorySummary.data = action.payload;
                state.NotificationCategorySummary.load = false;
            })
            .addCase(fetchNotificationCategorySummary.rejected, (state: EmailNotificationListState) => {
                state.NotificationCategorySummary.load = false;
            });
    },
});

export default NotificationSlice.reducer;

export const fetchEmailNotificationList = createAsyncThunk(
    "emailnotificationlistcount/fetchEmailNotificationList",
    async () => {
        const warehouse_id = localStorage.getItem('_warehouse_id');
        try {
            const { data } = await DataServer.get("api/GetNotificationUsers?warehouse_id=" + warehouse_id );
            return data.data;
        } catch (error) {
        }
    }
);

export const fetchNotificationCategory = createAsyncThunk(
    "NotificationCategory/fetchEmailNotificationList",
    async () => {
        try {
            const { data } = await DataServer.get("api/getNotificationCategory");
            return data.data;
        } catch (error) {
        }
    }
);

export const fetchNotificationCategorySummary = createAsyncThunk(
    "NotificationCategorySummary/fetchEmailNotificationList",
    async (param: {apiParam: any}) => {
        try {
            const { data } = await DataServer.post("api/getNotificationCategorySummary", {
                warehouse_id: param.apiParam.warehouse_id
            });
            return data.data;
        } catch (error) {
        }
    }
);